import { render, staticRenderFns } from "./PublicOrderFormLayout.vue?vue&type=template&id=b43c80ba&scoped=true&"
import script from "./PublicOrderFormLayout.vue?vue&type=script&lang=js&"
export * from "./PublicOrderFormLayout.vue?vue&type=script&lang=js&"
import style0 from "./PublicOrderFormLayout.vue?vue&type=style&index=0&id=b43c80ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43c80ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFadeTransition,VImg,VMain,VRow})
